export const downloadFile = (fileName, base64String) => {
  const downloadLink = document.createElement('a')
  const downloadFileName = fileName || new Date().toISOString()
  downloadLink.href = base64String
  downloadLink.download = downloadFileName
  downloadLink.click()
}
